import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

// 지점 정보. CMS(branches 테이블)와 같은 내용이며, 지점이 2곳뿐이고 주소/번호가
// 거의 바뀌지 않아 여기서 직접 관리한다. 사진이 준비되면 photo에 import한 이미지를 넣으면 된다.
// address: 화면에 보여줄 전체 주소.
// 지도는 업체명으로 검색해 등록된 지점 페이지로 바로 연결한다. 네이버와 카카오에
// 등록된 상호가 지점마다 달라서 검색어를 따로 둔다(2026-10 확인).
const CAMPUSES = [
  {
    name: '월산점',
    address: '경기도 남양주시 경춘로2290번길 5, 부영단지 내 상가 2동 102호, 201호, 202호 일부',
    naverQuery: '아나톨레어학원 월산점',
    kakaoQuery: '아나톨레어학원 월산점',
    phone: '031-559-9270',
    photo: null,
  },
  {
    name: '호평점',
    address: '경기도 남양주시 백봉로 32, 두산알프하임 B동 상가 202호, 202A호 일부',
    naverQuery: '아나톨레어학원 호평점',
    kakaoQuery: '호평아나톨레어학원',
    phone: '031-594-9270',
    photo: null,
  },
];

const naverMapUrl = (q) => `https://map.naver.com/p/search/${encodeURIComponent(q)}`;
const kakaoMapUrl = (q) => `https://map.kakao.com/?q=${encodeURIComponent(q)}`;

const PinIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

const PhoneIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 5.5C4 4.7 4.7 4 5.5 4h2.2c.7 0 1.3.5 1.5 1.2l.7 3a1.5 1.5 0 0 1-.5 1.5l-1.3 1a12 12 0 0 0 5.2 5.2l1-1.3a1.5 1.5 0 0 1 1.5-.5l3 .7c.7.2 1.2.8 1.2 1.5v2.2c0 .8-.7 1.5-1.5 1.5A15.5 15.5 0 0 1 4 5.5Z"
    />
  </svg>
);

function CampusCard({ campus, index }) {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <div
      ref={ref}
      className={`bg-primary-background rounded-[30px] desktop:rounded-[40px] shadow-lg overflow-hidden ${
        inView ? 'animate-fadeSlideUp' : ''
      }`}
      style={{ animationDelay: `${index * 150}ms` }}
    >
      {campus.photo && (
        <img src={campus.photo} alt={`${campus.name} 전경`} className="w-full h-[220px] desktop:h-[280px] object-cover" />
      )}

      <div className="px-[24px] py-[28px] desktop:px-[40px] desktop:py-[40px]">
        <h3 className="text-primary font-inter font-semibold text-headline-small desktop:text-headline-medium">
          {campus.name}
        </h3>
        <div className="mt-[6px] h-[3px] w-[40px] bg-tertiary rounded-full" />

        <dl className="mt-[24px] desktop:mt-[32px] flex flex-col gap-[16px]">
          <div className="flex items-start gap-[12px]">
            <PinIcon className="w-[22px] h-[22px] shrink-0 text-primary mt-[2px]" />
            <div>
              <dt className="sr-only">주소</dt>
              <dd className="kr-font text-primary-text text-body-large desktop:text-title-medium leading-relaxed">
                {campus.address}
              </dd>
            </div>
          </div>

          <div className="flex items-center gap-[12px]">
            <PhoneIcon className="w-[22px] h-[22px] shrink-0 text-primary" />
            <div>
              <dt className="sr-only">전화번호</dt>
              <dd>
                <a
                  href={`tel:${campus.phone.replace(/-/g, '')}`}
                  className="kr-font text-primary-text text-body-large desktop:text-title-medium hover:text-primary transition-colors"
                >
                  {campus.phone}
                </a>
              </dd>
            </div>
          </div>
        </dl>

        <div className="mt-[28px] desktop:mt-[36px] flex flex-wrap gap-[10px]">
          <a
            href={naverMapUrl(campus.naverQuery)}
            target="_blank"
            rel="noreferrer"
            className="px-[20px] py-[11px] rounded-lg bg-primary text-primary-background text-label-large font-semibold kr-font hover:shadow-md transition-shadow"
          >
            네이버 지도
          </a>
          <a
            href={kakaoMapUrl(campus.kakaoQuery)}
            target="_blank"
            rel="noreferrer"
            className="px-[20px] py-[11px] rounded-lg border border-custom2 text-secondary-text text-label-large font-semibold kr-font hover:border-primary hover:text-primary transition-colors"
          >
            카카오맵
          </a>
          <a
            href={`tel:${campus.phone.replace(/-/g, '')}`}
            className="px-[20px] py-[11px] rounded-lg border border-custom2 text-secondary-text text-label-large font-semibold kr-font hover:border-primary hover:text-primary transition-colors tablet:hidden"
          >
            전화 걸기
          </a>
        </div>
      </div>
    </div>
  );
}

export default function CampusPage() {
  const { ref: heroRef, inView: heroInView } = useInView({ threshold: 0.3, triggerOnce: true });

  return (
    <div>
      {/* 상단 배너 */}
      <section ref={heroRef} className="relative overflow-hidden bg-primary">
        <div className="absolute top-[15%] left-[8%] w-[220px] h-[220px] rounded-full bg-white/10 animate-float" />
        <div className="absolute bottom-[10%] right-[10%] w-[160px] h-[160px] rounded-full bg-white/10 animate-floatDelay" />
        <div className="absolute top-[45%] right-[28%] w-[110px] h-[110px] rounded-full bg-white/10 animate-floatSlow" />

        <div className="relative max-w-[1480px] mx-auto px-[20px] desktop:px-[50px] py-[70px] desktop:py-[120px] text-primary-background text-center">
          <h1
            className={`font-inter font-bold text-headline-medium desktop:text-display-medium ${
              heroInView ? 'animate-fadeSlideUp' : ''
            }`}
          >
            학원찾기
          </h1>
          <p
            className={`kr-font mt-[16px] desktop:mt-[24px] text-title-small desktop:text-headline-small leading-relaxed desktop:leading-[46px] ${
              heroInView ? 'animate-fadeSlideUp' : ''
            }`}
          >
            아나톨레 어학원은 남양주에 두 곳의 캠퍼스를 운영하고 있습니다.
            <br />
            가까운 캠퍼스로 편하게 문의해 주세요.
          </p>
        </div>
      </section>

      {/* 지점 목록 */}
      <section className="bg-alternate py-[50px] desktop:py-[100px] px-[20px] desktop:px-[50px]">
        <div className="max-w-[1480px] mx-auto">
          <div className="grid grid-cols-1 tablet:grid-cols-2 gap-[24px] desktop:gap-[40px]">
            {CAMPUSES.map((campus, i) => (
              <CampusCard key={campus.name} campus={campus} index={i} />
            ))}
          </div>

          {/* 하단 안내 */}
          <div className="mt-[40px] desktop:mt-[70px] bg-primary-background rounded-[30px] desktop:rounded-[40px] shadow-lg px-[24px] py-[32px] desktop:px-[60px] desktop:py-[50px] text-center">
            <h2 className="text-primary font-inter font-semibold text-headline-small desktop:text-headline-medium">
              상담이 필요하신가요?
            </h2>
            <p className="kr-font mt-[14px] desktop:mt-[20px] text-secondary-text text-body-large desktop:text-title-medium leading-relaxed">
              방문 상담은 전화로 미리 예약해 주시면 더 자세히 안내해 드릴 수 있습니다.
            </p>
            <Link
              to="/inquiry"
              className="inline-block mt-[26px] desktop:mt-[36px] px-[40px] py-[15px] bg-primary rounded-lg text-primary-background text-title-small desktop:text-headline-small font-semibold font-inter hover:shadow-md transition-shadow"
            >
              입학문의
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
